module.exports = "footer div{font-size:11px;display:flex;justify-content:center;align-items:center;height:50px}\n"